export const turnOnNoScroll = () => {
  document.getElementById('app').classList.add('no-scroll')
}

export const turnOffNoScroll = () => {
  document.getElementById('app').classList.remove('no-scroll')
}
